export default __webpack_public_path__ + "bffcef46d15fbdf21c4925167e4311a6.png";